/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import GroupActions from 'groups/actions/GroupActions';
import Group from 'entities/Group';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

type Props = {
  group: Group,
  onActionCompletion: Function,
  onRequestHide?: () => any,
};

export default class RestoreClassConfirmDialog extends React.Component<Props> {
  onSuccess = (group: Group) => {
    ToastActions.showSuccessToast('Class restored');
    this.props.onActionCompletion(group);
  };
  onError = (error: Object) => {
    ToastActions.showErrorToast(error.message);
  };
  handleRestore = () => {
    const { group } = this.props;
    const orgId = group.getOriginalOrganizationId() || null;

    return GroupActions.restoreGroup(group, orgId).then(this.onSuccess, this.onError);
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="RestoreClassConfirmDialog"
        group={this.props.group}
        title="Restore this class?"
        subtext={`${this.props.group.getName()} will reappear in your class list. You’ll also be able to send class announcements again.`}
        actionButtonText="Restore"
        cancelButtonText="Cancel"
        preConfirmPromise={this.handleRestore}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
